import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

import { CORE_ASSET_FIELDS } from 'app/src/components/Assets/queries';
import { NOTIFICATION_FIELDS } from 'app/src/components/Notifications/queries';

const ERRORS = `errors { path, message }`;

const SELLER_CORE_FIELDS = `
  id
  name
  companyName
  displayName
  fullDisplayName
  street
  city
  state
  postalCode { formatted, value}
  phoneNumber { formatted, value}
  feeType
  feeAmount
  inspectionFeeAmount
  canAddAsset
  showDatePaid
  primaryContactEmail
  status
  reviewedBy { id, fullName }
  reviewedAt
  reviewNotes
  contacts(scopes: ["visible"]) {
    id
    firstName
    lastName
    title
    email
    phoneNumber { formatted, value }
    sellerUser { id }
    primary
  }
`;

const SELLER_FIELDS = `
  ${SELLER_CORE_FIELDS}
  sellerUsers(scopes: ["visible", "ordered_by_first_name"]) {
    id
    firstName
    lastName
    email
    role
    invitationSentAt
    invitationAcceptedAt
    contact {
      firstName
      lastName
      email
    }
  }
  allTimeAssetCount
  assetCount
  assetsSold90DayCount
  primaryContactId
  assetCount
  releaseOption
  isEquiplinc
  feeMarkups {
    id
    feeType
    markupType
    amount
    defaultMarkup
  }
  files {
    id
    name
    fileUrl
  }
`;

const SELLER_VARIABLES = `
  $name: String!
  $companyName: String
  $street: String
  $city: String
  $state: String
  $postalCode: String
  $phoneNumber: String
  $feeType: String
  $feeAmount: Decimal
  $inspectionFeeAmount: Decimal
  $releaseOption: String
  $canAddAsset: Boolean
  $showDatePaid: Boolean
  $reviewNotes: String
  $status: String
`;

const SELLER_ARGUMENTS = `
  name: $name
  companyName: $companyName
  street: $street
  city: $city
  state: $state
  postalCode: $postalCode
  phoneNumber: $phoneNumber
  feeType: $feeType
  feeAmount: $feeAmount
  inspectionFeeAmount: $inspectionFeeAmount
  releaseOption: $releaseOption
  canAddAsset: $canAddAsset
  showDatePaid: $showDatePaid
  reviewNotes: $reviewNotes
  status: $status
`;

const SELLER_FIELDS_AND_ERRORS = `
  seller {
    ${SELLER_FIELDS}
  }
  ${ERRORS}
`;

export const SELLERS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    sellersWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${SELLER_CORE_FIELDS}
        assetCount
      }
      count
      pendingReviewCount
    }
  }
`;

export const CREATE_SELLER = gql`
  mutation CreateSeller(
    ${SELLER_VARIABLES}
  ) {
    createSeller(
      ${SELLER_ARGUMENTS}
    ) {
      ${SELLER_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_SELLER = gql`
  mutation UpdateSeller(
    $id: ID!
    $primaryContactId: ID
    ${SELLER_VARIABLES}
  ) {
    updateSeller(
      id: $id
      primaryContactId: $primaryContactId
      ${SELLER_ARGUMENTS}
    ) {
      ${SELLER_FIELDS_AND_ERRORS}
    }
  }
`;

export const SELLER = gql`
  ${NOTIFICATION_FIELDS}
  query SELLER($id: ID!) {
    seller(id: $id) {
      ${SELLER_FIELDS}
      upcomingSaleAssets {
        id
        lotNumber
        correctedLotNumber
        sale { id, saleOn }
        asset {
          ${CORE_ASSET_FIELDS}
          seller { id }
          photos { id, url }
        }
      }
      assignmentNotifications {
        ...NotificationFields
        seller { id, name }
      }
    }
  }
`;

export const HIDE_SELLER = gql`
  mutation HideSeller($id: ID!) {
    hideSeller(id: $id) {
      seller {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const UNHIDE_SELLER = gql`
  mutation UnhideSeller($id: ID!) {
    unhideSeller(id: $id) {
      seller {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

